import { FunctionComponent } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface Props {
  title: string
  content: string
}

export const RegulationAccordion: FunctionComponent<Props> = ({
  title,
  content,
}) => {
  return (
    <Box
      sx={{
        marginBottom: '24px',
      }}
    >
      <Accordion
        sx={{
          backgroundColor: '#fff',
          boxShadow: 'none',
          border: '1px solid #f1f2f4',
          borderRadius: '4px',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color="primary" />}
          aria-controls="panel1"
          id="panel1"
          sx={{
            '& .MuiAccordionSummary-content': {
              margin: '16px 0',
              color: '#283a5b',
              fontWeight: {
                xs: 400,
                md: 500,
              },
            },
          }}
        >
          {title}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            padding: '0 16px 16px 32px',
            position: 'relative',
            marginBottom: '16px',
            whiteSpace: 'pre-wrap',
            '&:before': {
              content: '""',
              width: '2px',
              height: '100%',
              position: 'absolute',
              left: '19px',
              top: '0',
              background: 'rgba(3, 34, 76)',
            },
          }}
        >
          {content}
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}
